import React, { useState } from "react";
import { Alert, Box, Link, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import { ReactComponent as UploadIcon } from "../../../assets/icons/upload-icon.svg";

const REJECTION_MESSAGES = {
  "invalid-type": "formato não suportado",
  "invalid-size": "excede o tamanho máximo de 30 MB",
};

const AssessmentsUploadDropzone = ({ onAddFiles }) => {
  const [rejectedFiles, setRejectedFiles] = useState([]);

  const handleDrop = (acceptedFiles, dropzoneRejectedFiles) => {
    const { rejected } = onAddFiles([
      ...acceptedFiles,
      ...dropzoneRejectedFiles,
    ]);
    setRejectedFiles(rejected);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop: handleDrop });

  return (
    <Box>
      <Box
        {...getRootProps({ role: "button" })}
        sx={{
          border: "2px dashed #E2E2E3",
          borderRadius: "8px",
          py: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />

        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "8px",
            bgcolor: "#EFEFEF",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <UploadIcon aria-hidden="true" focusable="false" />
        </Box>

        <Typography
          sx={{
            fontSize: "14px",
            color: "#333333",
            maxWidth: 210,
            textAlign: "center",
          }}
        >
          Arraste e solte um arquivo ou{" "}
          <Link component="span" underline="always" sx={{ color: "#185CFB" }}>
            clique aqui para selecionar
          </Link>
          .
        </Typography>

        <Typography sx={{ fontSize: "10px", color: "#646568" }}>
          Formato: PDF, DOC e DOCX (limite máximo de 30 MB)
        </Typography>
      </Box>

      {rejectedFiles.length > 0 && (
        <Alert
          severity="error"
          closeText="Fechar"
          onClose={() => setRejectedFiles([])}
          sx={{ mt: 2 }}
        >
          {rejectedFiles
            .map(
              (item) => `${item.file.name} (${REJECTION_MESSAGES[item.reason]})`
            )
            .join(", ")}
        </Alert>
      )}
    </Box>
  );
};

export default AssessmentsUploadDropzone;
